import { createReducer, on } from '@ngrx/store';
import {
  loadEntityList,
  loadEntityListSuccess,
  loadEntityListFailure,
  clearEntityList,
} from './entity.actions';

export interface EntityState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: EntityState = {
  data: null,
  loading: false,
  error: null,
};

export const entityReducer = createReducer(
  initialState,
  on(loadEntityList, (state) => ({ ...state, loading: true, error: null })),
  on(loadEntityListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadEntityListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearEntityList, (state) => ({ ...state, data: null }))
);
